import { Api } from '@monorepo/shared/apiClient';
import {
  AnalyticsSyncCacheEvents,
  invalidateAnalyticsSyncCache,
} from '@monorepo/shared/cacheRegisters/data2/analyticsSyncCacheRegister';
import { setCache as setAnalyticsSyncCache } from '@monorepo/shared/hooks/analyticsSync/useAnalyticsSync';
import { MutationConfig, useMutation } from 'react-query';

type useAnalyticsSyncActivateParams = {
  config?: MutationConfig<Api.ActivateAnalyticsSyncResponse, Api.ErrorResponse>;
};

export const useAnalyticsSyncActivate = (
  params?: useAnalyticsSyncActivateParams,
) =>
  useMutation(Api.activateAnalyticsSync, {
    ...params?.config,
    onSuccess: (createdAnalyticsSync, mutationFuncParams) => {
      const { organizationId } = mutationFuncParams;
      const keyParams = {
        organizationId,
        inputDatasetId: createdAnalyticsSync.inputDatasetId,
      };

      // Set cache for that single AnalyticsSync
      setAnalyticsSyncCache(keyParams, createdAnalyticsSync);
      invalidateAnalyticsSyncCache(AnalyticsSyncCacheEvents.CREATE, keyParams);

      return params?.config?.onSuccess?.(
        createdAnalyticsSync,
        mutationFuncParams,
      );
    },
  });
